import { useMemo, useRef, useState, useEffect } from 'react';

import { JourneyActionValuesTypes } from 'api/types';

import { getConditionDescription, descriptionLocale } from './description';

export const useConditionDescription = (
  values: JourneyActionValuesTypes['condition_v2'],
  locale?: typeof descriptionLocale
) => {
  const textClampedRef = useRef<HTMLDivElement | null>(null);

  const descriptionText = useMemo(() => {
    return getConditionDescription({
      values,
      textClampedRef,
      locale: locale ?? descriptionLocale,
      styled: true,
    });
  }, [values, locale]);

  const [isTextClamped, setIsTextClamped] = useState(false);

  useEffect(() => {
    const descriptionChildren = [...(textClampedRef?.current?.children ?? [])];
    const isClamped = descriptionChildren.some((child) => {
      return child.scrollHeight > child.clientHeight;
    });
    setIsTextClamped(isClamped);
  }, [descriptionText]);

  return { descriptionText, isTextClamped };
};
